﻿import { Component } from '@angular/core';
import { Tabla } from '../../tabla';

@Component({ template:  `
    <app-tabla [tabla]="tabla"></app-tabla>
` })
export class ResultadoUserComponent {

    tabla: Tabla = {
        titulo: 'Resultado',
        endPoint:'/rest-api/user/resultado',
        editable: true,
        nuevo: false,
        columnas: [
            {
                name: 'ID',
                prop: 'id',
                editable: false,
                resizeable: true,
                sortable: true,
                width: 50
            },
            {
                name: 'Categoria',
                prop: 'categoriaDeporte.categoria',
                cell: 'nombre',
                editable: false,
                resizeable: true,
                sortable: true,
                width: 100
            },
            {
                name: 'Deporte',
                prop: 'categoriaDeporte.deporte',
                cell: 'nombre',
                editable: false,
                resizeable: true,
                sortable: true,
                width: 100
            },
            {
                name: 'Sexo',
                prop: 'sexo',
                cell: 'nombre',
                editable: true,
                resizeable: true,
                sortable: true,
                width: 50
            },
            {
                name: 'Alumno',
                prop: 'alumno',
                cell: 'nombre',
                editable: true,
                resizeable: true,
                sortable: true,
                width: 280
            },
            {
                name: 'Puesto',
                prop: 'puesto',
                cell: 'nombre',
                editable: true,
                resizeable: true,
                sortable: true,
                width: 75
            },
            {
                name: 'Año',
                prop: 'anio',
                editable: true,
                resizeable: true,
                sortable: true,
                width: 75
            },
            {
                name: 'Valor',
                prop: 'valor',
                editable: true,
                resizeable: true,
                sortable: true,
                width: 150,
                icon: true,
                pattern: true
            },
            {
                name: 'Casa',
                prop: 'alumno.casa',
                cell: 'nombre',
                editable: false,
                resizeable: true,
                sortable: true,
                casa: true,
                width: 100
            }
        ]
    };

}
